import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";

import FYindSummary from "./Components/FYindSummary";
import FigmaSummary from "./Components/FigmaSummary";
import FreshmanSummary from "./Components/FreshmanSummary";
import GanapatiSummary from "./Components/GanapatiSummary";
import LogicaSummary from "./Components/LogicaSummary";
import Navbar from "./Components/Navbar";
import About from "./Components/Pages/About";
import Events from "./Components/Pages/Events";
import Home from "./Components/Pages/Home";
import Team from "./Components/Pages/Team";
import WebTeam from "./Components/Pages/WebTeam";
import PradyotSummary from "./Components/PradyotSummary";
import Pradyot_2Summary from "./Components/Pradyot_2Summary";
import Summary from "./Components/Summary";
import TechExplore from "./Components/TechExplore";
import TrinitySummary from "./Components/TrinitySummary";
import UiSummary from "./Components/UiSummary";
import CDevent from "./Components/childrensDay2022";
import WillPower from "./Components/willPowerABCs";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/events" element={<Events />}></Route>
          <Route path="/team" element={<Team />}></Route>
          <Route path="/webteam" element={<WebTeam />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/summary" element={<Summary />}></Route>
          <Route path="/poetry" element={<Summary />}></Route>
          <Route path="/ganapatisummary" element={<GanapatiSummary />}></Route>
          <Route path="/pradyotsummary" element={<PradyotSummary />}></Route>
          <Route path="/childrensday" element={<CDevent />}></Route>
          <Route path="/trinitysummary" element={<TrinitySummary />}></Route>
          <Route path="/logicasummary" element={<LogicaSummary />}></Route>
          <Route path="/uipath" element={<UiSummary />}></Route>
          <Route path="/techexplore" element={<TechExplore />}></Route>
          <Route path="/willpower" element={<WillPower />}></Route>
          <Route path="/pradyot_2summary" element={<Pradyot_2Summary />}></Route>
          <Route path="/freshmansummary" element={<FreshmanSummary />}></Route>
          <Route path="/fyindsummary" element={<FYindSummary />}></Route>
          <Route path="/figmasummary" element={<FigmaSummary />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
